<template>
  <Fragment>
    <section class="gtr-header-tools-country-time" @click="dialog.show">
      <img class="country-icon" alt="" :src="viewInfo.curCountry?.value.icon" />
      <span class="country-time">
        <p>{{ viewInfo.select.timeZone?.split?.('/')?.[1] || viewInfo.select.timeZone || '' }}</p>
        <p>{{ viewInfo.display.value }}</p>
      </span>
    </section>
    <pb-dialog
      class="gtr-header-tools-country-time-dialog"
      :close-on-click-modal="showClose && tipInfo.canClose"
      :close-on-press-escape="showClose && tipInfo.canClose"
      :show-close="showClose && tipInfo.canClose"
      :visible.sync="dialogVisible"
      :title="$t('Gattaran_Homepage__lXkk' /*设置国家、时区、语言*/)"
      width="784px"
    >
      <section v-if="tipInfo.showTip">
        <pb-alert class="gtr-country-switch-tip" :title="tipInfo.switchTip" type="warning" show-icon :closable="false"></pb-alert>
      </section>
      <section class="gtr-region-language">
        <p class="title">{{ $t('Gattaran_Homepage__lRUO' /*国家*/) }}</p>
        <section>
          <section v-for="country in userAuthCountry" :key="country.value" :class="['region-item', regionInfo.select?.region === country?.value ? 'region-select' : '']" @click="regionInfo.selectRegion(country)">
            <img :src="country.icon" alt="" />
            <span>{{ country.label }}</span>
          </section>
        </section>
        <p class="time-zone">
          <img src="@/assets/svg/info.svg" alt="" />
          <!--          时区：{{cityname}}-->
          <span>{{ decodeURIComponent($t('Gattaran_Homepage__QaKY', { cityname: encodeURIComponent(regionInfo?.timeZone?.value) })) }}</span>
        </p>
        <p class="title">{{ $t('Gattaran_Homepage__KYtj' /*语言*/) }}</p>
        <section>
          <section v-for="locale in regionInfo?.curLocale?.value" :key="locale.value" :class="['region-item', regionInfo?.select?.locale === locale?.value ? 'region-select' : '']" @click="regionInfo.selectLocale(locale)">
            <span>{{ locale.label }}</span>
          </section>
        </section>
      </section>
      <template #footer>
        <span class="dialog-footer">
          <pb-button v-if="showClose" @click="cancel">{{ tipInfo.backText || $t('Gattaran_Homepage__rxJe' /*取消*/) }}</pb-button>
          <pb-button type="primary" :disabled="!canSubmit" @click="submit()">{{ tipInfo.confirmText || $t('Gattaran_Homepage__ktsW' /*确定*/) }}</pb-button>
        </span>
      </template>
    </pb-dialog>
    <section>
      <CountrySwitchDialog ref="countrySwitchDialog" :info="info" @handleChange="handleChange" />
    </section>
  </Fragment>
</template>
<script setup>
import { useAppStore, useStore } from '@/store';
import { computed, onMounted, onUnmounted, reactive, ref, watch, watchEffect } from 'vue';
import { updateUserConfig } from '@/services';
import CountrySwitchDialog from '@/components/country-switch-dialog';
import { eventBus, fullPath, gtrListenEvents } from '@/micro-app';
import { env } from '@/utils';
import displayTime from '@/utils/display-time';

const name = 'Country';

const appStore = useAppStore();
const userAuthCountry = computed(() => appStore.userAuthCountry || []);
const dialogVisible = ref(false);
const countrySwitchDialog = ref(null);
const showClose = ref(true);
const info = ref({});
const tipInfo = reactive({
  switchTip: '',
  backText: '',
  confirmText: '',
  canClose: true,
  showTip: false,
  arouse: false,
  backUrl: '',
});

/**
 * 展示相关逻辑
 * @returns {{select: UnwrapNestedRefs<{timeZone: string, region: string, locale: string}>, curCountry: ComputedRef<unknown>, display: Ref<UnwrapRef<string>>, icon: Ref<UnwrapRef<string>>}}
 */
function useViewInfo() {
  // region: 'MX',
  // locale: 'zh-CN',
  // timeZone: 'America/Mexico_City',
  const select = reactive({
    region: '',
    locale: '',
    timeZone: '',
  });
  const icon = ref('');
  // 当前国家的对象
  const curCountry = computed(() => userAuthCountry.value?.find((i) => i.value === select.region) || {});
  onMounted(() => {
    const userInfo = env.get('userInfo');
    if (!userInfo.country || !userInfo.locale || !userInfo.timezone) {
      // 没有的话强制弹窗
      dialogVisible.value = true;
      showClose.value = false;
    } else {
      select.region = userInfo.country;
      select.locale = userInfo.locale;
      select.timeZone = userInfo.timezone;
      // 启动时间轮询
    }
  });

  return {
    select,
    display: displayTime,
    icon,
    curCountry,
  };
}
/**
 * 子应用调起基座选择器
 * @param { countryCode:string 前往国家 title?:string 对话框标题 isShowTip?:boolean 是否展示提示 tipMessage?: string 对话框内容 confirmText?: string 自定义按钮文案 backText?: string 自定义按钮文案 backUrl?: string 自定义回跳地址 canClose?: boolean 自定义对话框关闭状态 canBack?: boolean 自定义点击按钮后动作 }
 * @returns null
 */
function useArouser() {
  onMounted(() => {
    // 监控子应用环境是否与当前一致
    gtrListenEvents.GTR_LISTEN_EVENT_COUNTRY_SWITCH_DIALOG((data) => {
      const userInfo = env.get('userInfo');
      const { countryCode, title, isShowTip = true, tipMessage, confirmText, backText, backUrl, canClose = false, canBack = true } = data;
      const userJumpToCountry = userAuthCountry.value?.find((i) => i.value === countryCode) || {};
      const userJumpToCountryTimeZone = userJumpToCountry?.children?.[0]?.value || '';
      const userJumpToCountryLocale = userJumpToCountry?.locale.find((i) => i.value === userInfo.locale);
      // 如果语言匹配
      if (userJumpToCountryLocale) {
        countrySwitchDialog.value.show = true;
        info.value = {
          country: countryCode,
          timezone: userJumpToCountryTimeZone,
          locale: userJumpToCountryLocale?.value,
          title,
          tipMessage,
          confirmText,
          backText,
          backUrl,
          canClose,
          canBack,
        };
      } else {
        tipInfo.showTip = isShowTip;
        tipInfo.switchTip = tipMessage;
        tipInfo.backText = backText;
        tipInfo.confirmText = confirmText;
        tipInfo.backUrl = backUrl;
        tipInfo.canClose = canClose;
        dialogVisible.value = true;
      }
    });
  });
}
// 地区语言弹窗相关
function useRegionBox() {
  const select = reactive({
    region: '',
    locale: '',
  });
  const curCountry = computed(() => userAuthCountry.value?.find((i) => i.value === select.region) || {});
  const timeZone = computed(() => curCountry?.value?.children?.[0]?.value || '');
  const curLocale = computed(() => curCountry?.value?.locale || []);
  watch(
    () => dialogVisible.value,
    (visible) => {
      if (visible) {
        const userInfo = env.get('userInfo');
        select.region = userInfo.country;
        select.locale = userInfo.locale;
      }
    },
    {
      immediate: true,
    },
  );
  watchEffect(() => {
    const hasI = curLocale.value.find((i) => i.value === select.locale);
    if (!hasI) {
      select.locale = curLocale?.value?.[0]?.value || 'zh-CN';
    }
  });
  return {
    timeZone,
    select,
    selectRegion(evt) {
      select.region = evt.value;
    },
    curLocale,
    curCountry,
    selectLocale(evt) {
      select.locale = evt.value;
    },
  };
}

// 弹窗操作相关
function useDialogShow() {
  function show() {
    dialogVisible.value = true;
  }

  function handleClose(done) {
    done();
  }

  return {
    show,
    handleClose,
  };
}

// 修改环境配置
function modifyUserConfig(params) {
  return updateUserConfig(params).then((_) => {
    dialogVisible.value = false;
    const store = useStore();
    store.switch();
    window.location.reload();
  });
}

const viewInfo = useViewInfo();
const dialog = useDialogShow();
const regionInfo = useRegionBox();
const arouser = useArouser();
const canSubmit = computed(() => regionInfo.select.region && regionInfo.select.locale && regionInfo.timeZone.value);

const submit = (arouse = false) => {
  let params;
  if (arouse) {
    const { country = '', timezone = '', locale = '' } = info.value;
    params = {
      country,
      timezone,
      locale,
    };
  } else {
    params = {
      country: regionInfo.select.region,
      timezone: regionInfo.timeZone.value,
      locale: regionInfo.select.locale,
    };
  }
  modifyUserConfig(params);
};
const cancel = () => {
  const { backUrl = '' } = tipInfo;
  // 指定返回路径
  if (backUrl) {
    window.location.href = fullPath(backUrl);
  } else {
    dialogVisible.value = false;
  }
};
const handleChange = () => {
  submit(true);
};
onUnmounted(() => {
  eventBus.$off('GTR_LISTEN_EVENT_COUNTRY_SWITCH_DIALOG');
});
</script>
<style lang="scss" scoped>
@import '../style';
.gtr-header-tools-country-time {
  @extend .gtr-header_tool_item;
  height: 40px;
  line-height: 40px;
  margin-top: 10px;
  display: flex;

  .country-icon {
    width: 25px;
    height: 16px;
    vertical-align: middle;
    margin-right: 5px;
    margin-top: 10px;
  }

  .country-time {
    //vertical-align: middle;
    p {
      min-width: 58px;
      margin: 0;
      padding: 0;
      color: #c2c4cc;
      font-size: 12px;
      line-height: 18px;
    }

    p:last-child {
      color: #ffffff;
      font-size: 14px;
    }
  }
}

.gtr-region-language {
  padding-left: 24px;
  p {
    padding: 0;
    margin: 0;
  }

  .title {
    margin-top: 16px;
    font-weight: 600;
    line-height: 22px;
    color: #8d9099;
  }

  .time-zone {
    margin-top: 16px;

    img {
      width: 14px;
      color: #fff;
      vertical-align: middle;
      margin-right: 3px;
    }

    span {
      vertical-align: middle;
      font-family: PingFangSC-Regular;
      font-size: 12px;
      color: #595c66;
      line-height: 20px;
      font-weight: 400;
    }

    span,
    img {
      vertical-align: middle;
    }
  }

  .region-item {
    box-sizing: border-box;
    display: inline-block;
    width: 172px;
    height: $headerHeight;
    border: 1px solid #e9eaee;
    border-radius: 4px;
    margin-right: 16px;
    margin-top: 16px;
    line-height: $headerHeight;
    padding-left: 16px;
    cursor: pointer;

    img {
      width: 36px;
      height: 26px;
      margin-right: 12px;
      vertical-align: middle;
    }

    &:nth-child(4n + 1) {
      margin-left: 0;
    }

    &.region-select {
      border: 1px solid #ff7a45;
      color: #282b33;
      font-weight: bold;
    }

    &:hover {
      border: 1px solid #ff7a45;
    }
  }
}
</style>
<style lang="scss">
.gtr-header-tools-country-time-dialog {
  z-index: 11112 !important;
  .pb-dialog {
    max-width: 95%;
  }
  .pb-dialog__body {
    padding: 0 0 24px !important;
  }
}
</style>
